<div class="page">
  <div class="header">
    <h1 class="header-title">
      <mat-icon>people</mat-icon>
      Passagiers
    </h1>
    <div class="header-buttons">
      @if (!loading() && !isOnlyRidePlanner()) {
        @if (publicSettings?.sepaEnabled && shouldShowSepaButton()) {
          <button
            class="header-button sepa-button"
            mat-icon-button
            aria-label="SEPA machtigingsbestand aanmaken"
            (click)="requestSepaCreation()"
          >
            <mat-icon>euro</mat-icon>
            <span class="button-text">Incasso aanmaken</span>
          </button>
        }

        <button
          class="header-button export-button"
          mat-icon-button
          aria-label="Importeren en exporteren"
          (click)="openImportExport()"
          [class.spinner]="processing()"
          [disabled]="processing()"
        >
          <mat-icon>import_export</mat-icon>
          <span class="button-text">Exporteren/Importeren</span>
        </button>
      }
    </div>
  </div>
  @if (!loading()) {
    <mat-card class="content" role="region" aria-labelledby="users-list-title" [attr.aria-busy]="loading()">
      <div class="content-header">
        <h2 id="users-list-title" class="title">
          {{ !filterForm.controls.showHidden.value ? 'Actieve' : 'Verstopte' }} passagiers
          <span>({{ filteredUsers().length }})</span>
        </h2>
        <form [formGroup]="filterForm">
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label class="placeholder">Zoeken</mat-label>
            <input matInput placeholder="Zoeken" autocomplete="off" formControlName="search" />
            <button
              mat-icon-button
              matSuffix
              aria-label="Zoekopdracht wissen"
              (click)="clearSearch(); $event.stopPropagation()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </form>
      </div>
      <form class="filters" [formGroup]="filterForm">
        <div class="filter-buttons">
          <button mat-stroked-button class="filter-button primary-color" [matMenuTriggerFor]="cardMenu">
            @if (
              filterForm.value.cardFilter === filterOption.HasCard ||
              filterForm.value.cardFilter === filterOption.NoCard
            ) {
              <mat-icon>checked</mat-icon>
            }
            @if (filterForm.value.cardFilter === filterOption.HasCard) {
              Met kaart
            } @else if (filterForm.value.cardFilter === filterOption.NoCard) {
              Zonder kaart
            } @else {
              <span class="inactive">Kaart</span>
            }
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #cardMenu="matMenu">
            <button
              [class.active-list-item]="filterForm.value.cardFilter === filterOption.HasCard"
              mat-menu-item
              (click)="setFilter(filterOption.HasCard)"
            >
              Met kaart
            </button>
            <button
              [class.active-list-item]="filterForm.value.cardFilter === filterOption.NoCard"
              mat-menu-item
              (click)="setFilter(filterOption.NoCard)"
            >
              Zonder kaart
            </button>
          </mat-menu>

          @if (!isOnlyRidePlanner()) {
            <button mat-stroked-button class="filter-button primary-color" [matMenuTriggerFor]="planMenu">
              @if (
                filterForm.value.planFilter === filterOption.HasPlan ||
                filterForm.value.planFilter === filterOption.NoPlan
              ) {
                <mat-icon>checked</mat-icon>
              }
              @if (filterForm.value.planFilter === filterOption.HasPlan) {
                Met betaalplan
              } @else if (filterForm.value.planFilter === filterOption.NoPlan) {
                Zonder betaalplan
              } @else {
                <span class="inactive">Betaalplan</span>
              }
              <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #planMenu="matMenu">
              <button
                [class.active-list-item]="filterForm.value.planFilter === filterOption.HasPlan"
                mat-menu-item
                (click)="setFilter(filterOption.HasPlan)"
              >
                Met betaalplan
              </button>
              <button
                [class.active-list-item]="filterForm.value.planFilter === filterOption.NoPlan"
                mat-menu-item
                (click)="setFilter(filterOption.NoPlan)"
              >
                Zonder betaalplan
              </button>
            </mat-menu>

            <button mat-stroked-button class="filter-button primary-color" [matMenuTriggerFor]="paymentMethodMenu">
              @if (
                filterForm.value.paymentMethodFilter === filterOption.PaymentMethodMollie ||
                filterForm.value.paymentMethodFilter === filterOption.PaymentMethodSepa
              ) {
                <mat-icon>checked</mat-icon>
              }
              @if (filterForm.value.paymentMethodFilter === filterOption.PaymentMethodMollie) {
                Mollie
              } @else if (filterForm.value.paymentMethodFilter === filterOption.PaymentMethodSepa) {
                SEPA
              } @else {
                <span class="inactive">Betaalmethode</span>
              }
              <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #paymentMethodMenu="matMenu">
              <button
                [class.active-list-item]="filterForm.value.paymentMethodFilter === filterOption.PaymentMethodMollie"
                mat-menu-item
                (click)="setFilter(filterOption.PaymentMethodMollie)"
              >
                Mollie
              </button>
              <button
                [class.active-list-item]="filterForm.value.paymentMethodFilter === filterOption.PaymentMethodSepa"
                mat-menu-item
                (click)="setFilter(filterOption.PaymentMethodSepa)"
              >
                SEPA
              </button>
            </mat-menu>

            <button mat-stroked-button class="filter-button primary-color" [matMenuTriggerFor]="additionalFiltersMenu">
              @if (
                filterForm.value.warningFilter === filterOption.WarningLowCredits ||
                filterForm.value.warningFilter === filterOption.WarningPaymentError ||
                filterForm.value.warningFilter === filterOption.WarningSendSepaMandate ||
                filterForm.value.warningFilter === filterOption.WarningUploadSepaMandate
              ) {
                <mat-icon>checked</mat-icon>
              }
              @if (filterForm.value.warningFilter === filterOption.WarningLowCredits) {
                Te weinig credits
              } @else if (filterForm.value.warningFilter === filterOption.WarningPaymentError) {
                Fout tijdens betalen
              } @else if (filterForm.value.warningFilter === filterOption.WarningSendSepaMandate) {
                Verstuur SEPA machtiging
              } @else if (filterForm.value.warningFilter === filterOption.WarningUploadSepaMandate) {
                Upload SEPA machtiging
              } @else {
                <span class="inactive">Meldingen</span>
              }
              <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #additionalFiltersMenu="matMenu">
              <button
                [class.active-list-item]="filterForm.value.warningFilter === filterOption.WarningLowCredits"
                mat-menu-item
                (click)="setFilter(filterOption.WarningLowCredits)"
              >
                Te weinig credits
              </button>
              <button
                [class.active-list-item]="filterForm.value.warningFilter === filterOption.WarningPaymentError"
                mat-menu-item
                (click)="setFilter(filterOption.WarningPaymentError)"
              >
                Fout tijdens betalen
              </button>
              @if (publicSettings.sepaEnabled) {
                <button
                  [class.active-list-item]="filterForm.value.warningFilter === filterOption.WarningSendSepaMandate"
                  mat-menu-item
                  (click)="setFilter(filterOption.WarningSendSepaMandate)"
                >
                  Verstuur SEPA machtiging
                </button>
              }
              @if (publicSettings.sepaEnabled) {
                <button
                  [class.active-list-item]="filterForm.value.warningFilter === filterOption.WarningUploadSepaMandate"
                  mat-menu-item
                  (click)="setFilter(filterOption.WarningUploadSepaMandate)"
                >
                  Upload SEPA machtiging
                </button>
              }
            </mat-menu>
          }
        </div>
        <div class="filter-actions">
          @if (hasActiveFilters()) {
            <button
              mat-icon-button
              aria-label="Alle filters wissen"
              matTooltip="Alle filters wissen"
              (click)="clearAllFilters()"
            >
              <mat-icon>filter_alt_off</mat-icon>
            </button>
          }
          <button
            mat-icon-button
            [attr.aria-label]="
              this.filterForm.value.showHidden ? 'Verstopte passagiers verbergen' : 'Verstopte passagiers tonen'
            "
            (click)="this.filterForm.controls.showHidden.setValue(!this.filterForm.value.showHidden)"
            [matTooltip]="
              this.filterForm.value.showHidden
                ? 'Laat verstopte passagiers niet meer zien'
                : 'Laat verstopte passagiers zien'
            "
          >
            @if (this.filterForm.value.showHidden) {
              <mat-icon> visibility_off </mat-icon>
            }
            @if (!this.filterForm.value.showHidden) {
              <mat-icon> visibility </mat-icon>
            }
          </button>
        </div>
      </form>
      <div class="list-items">
        <div class="list-item-row headers">
          <div class="list-item-col">
            Naam
            <button
              mat-icon-button
              (click)="this.filterForm.controls.aToZ.setValue(!this.filterForm.value.aToZ)"
              aria-label="Sorteren omdraaien"
              matTooltip="Sorteren omdraaien"
            >
              @if (this.filterForm.value.aToZ) {
                <mat-icon> arrow_upward </mat-icon>
              }
              @if (!this.filterForm.value.aToZ) {
                <mat-icon> arrow_downward </mat-icon>
              }
            </button>
          </div>
          <div class="list-item-col">E-mail</div>
          @if (this.askBirthDay) {
            <div class="list-item-col hide-column">Geboortedatum</div>
          }
          <div class="list-item-col">Telefoonnummer</div>
          @if (!isOnlyRidePlanner()) {
            <div class="list-item-col hide-column-2">Plan</div>
          }
          <div class="list-item-col hide-column">Opmerking (Algemeen)</div>
          <div class="list-item-col hide-column">Registratiedatum</div>
          <div class="list-item-col hide-column-2">Kaartnummer</div>
          @if (!isOnlyRidePlanner()) {
            <div class="list-item-col hide-column">Openstaande betaling</div>
          }
          <div class="list-item-col"></div>
        </div>
        <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
          @for (user of filteredUsers(); track user) {
            <div
              class="list-item-row"
              role="button"
              tabindex="0"
              aria-label="Gebruiker openen"
              (click)="editUser(user)"
              (keydown.enter)="editUser(user)"
              (keydown.space)="$event.preventDefault(); editUser(user)"
            >
              <div
                class="list-item-col"
                [class.no-warning-icon]="user.warnings.length === 0"
                [class.has-warning-icon]="user.warnings.length !== 0"
              >
                @if (user.warnings.length !== 0) {
                  <div class="icons-wrapper">
                    @if (
                      user.warnings.length > 1 &&
                      user.warnings[0].description !== 'Er moet een SEPA machtiging verstuurd worden.'
                    ) {
                      <span matTooltip="De passagier heeft meerdere waarschuwingen." matTooltipPosition="right">
                        <div class="circle-icon red-bg">{{ user.warnings.length }}</div>
                      </span>
                    }
                    @if (
                      user.warnings.length > 1 &&
                      user.warnings[0].description === 'Er moet een SEPA machtiging verstuurd worden.'
                    ) {
                      <span [matTooltip]="user.warnings[0].description" matTooltipPosition="right">
                        <div class="circle-icon" [ngClass]="user.warnings[0].colorClass">
                          {{ user.warnings[0].type === 'text' ? user.warnings[0].iconOrText : '' }}
                          @if (user.warnings[0].type === 'icon') {
                            <mat-icon>{{ user.warnings[0].iconOrText }}</mat-icon>
                          }
                        </div>
                      </span>
                    }
                    @if (user.warnings.length === 1) {
                      <span [matTooltip]="user.warnings[0].description" matTooltipPosition="right">
                        <div class="circle-icon" [ngClass]="user.warnings[0].colorClass">
                          {{ user.warnings[0].type === 'text' ? user.warnings[0].iconOrText : '' }}
                          @if (user.warnings[0].type === 'icon') {
                            <mat-icon>{{ user.warnings[0].iconOrText }}</mat-icon>
                          }
                        </div>
                      </span>
                    }
                  </div>
                }
                {{ user.name ?? '' }} {{ user.lastName ?? '' }} ({{ user.credits ?? '' }})
              </div>
              <div class="list-item-col">{{ user.email ?? '' }}</div>
              @if (this.askBirthDay) {
                <div class="list-item-col hide-column">
                  {{ user?.birthDate ? moment(valueToDate(user.birthDate)).format('DD-MM-YYYY') : '' }}
                </div>
              }
              <div class="list-item-col">
                {{ user.phoneNumber ?? user.phone ?? '' }}
              </div>
              @if (!isOnlyRidePlanner()) {
                <div class="list-item-col hide-column-2">
                  @if (user?.currentPlan?.name) {
                    <mat-chip>
                      {{ user.currentPlan.name }}
                    </mat-chip>
                  }
                </div>
              }
              <div class="list-item-col hide-column">
                {{ user.hiddenRemarks ?? '' }}
              </div>
              <div class="list-item-col hide-column">
                {{ user.createdAt ? moment(valueToDate(user.createdAt)).format('DD-MM-YYYY') : '' }}
              </div>
              <div class="list-item-col hide-column-2">{{ user.cardId ?? '' }}</div>
              @if (!isOnlyRidePlanner()) {
                <div class="list-item-col hide-column">
                  {{
                    user?.sepaData?.sepaSendOn ? moment(valueToDate(user.sepaData.sepaSendOn)).format('DD-MM-YYYY') : ''
                  }}
                </div>
              }
              <div class="list-item-col list-item-buttons">
                <button
                  mat-icon-button
                  aria-label="Acties"
                  (click)="$event.stopPropagation()"
                  [matMenuTriggerFor]="menu"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu>
                  <button mat-menu-item (click)="showFutureRides(user)">
                    <span>Toekomstige ritten bekijken</span>
                  </button>
                  @if (!isOnlyRidePlanner()) {
                    <button mat-menu-item (click)="showCreditsHistory(user)">
                      <span>Credits historie</span>
                    </button>
                    <button mat-menu-item (click)="changeCredits('add', user)">
                      <span>Credits toevoegen</span>
                    </button>
                    <button mat-menu-item (click)="changeCredits('remove', user)">
                      <span>Credits verminderen</span>
                    </button>
                    <a
                      mat-menu-item
                      [attr.href]="user.email ? 'mailto:' + user.email : null"
                      [attr.aria-disabled]="!user.email"
                      [class.disabled]="!user.email"
                      [attr.tabindex]="!user.email ? -1 : null"
                    >
                      <span>Verstuur e-mail</span>
                    </a>
                    <button mat-menu-item (click)="copyEmail(user.email)">
                      <span>Kopieer e-mail</span>
                    </button>
                    @if (!user.hidden) {
                      <button mat-menu-item (click)="changeHiddenStatus('hide', user)">
                        <span>Verstop passagier</span>
                      </button>
                    }
                    @if (user.hidden) {
                      <button mat-menu-item (click)="changeHiddenStatus('show', user)">
                        <span>Passagier weer laten zien</span>
                      </button>
                    }
                    <button
                      [disabled]="user.deleted || user.id === currentUser.id"
                      mat-menu-item
                      (click)="deleteUser(user)"
                    >
                      <span>Verwijder passagier</span>
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
          }
          <div class="list-item-row"></div>
        </cdk-virtual-scroll-viewport>
      </div>
    </mat-card>
  }
  @if (loading()) {
    <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }

  <!-- Address validation progress overlay -->
  @if (importing() || addressValidationService.isValidating() || addressValidationService.isBulkValidating()) {
    <div class="validation-overlay">
      <div class="validation-progress-container" role="status" aria-live="polite" aria-atomic="true">
        <h3>Importeren...</h3>
        <mat-progress-bar
          mode="determinate"
          [value]="
            addressValidationService.isBulkValidating() ? addressValidationService.bulkProgress() : importProgress()
          "
        ></mat-progress-bar>
        <p class="progress-text">
          {{
            addressValidationService.isBulkValidating() ? addressValidationService.bulkProgress() : importProgress()
          }}% voltooid
        </p>
      </div>
    </div>
  }
</div>
@if (!loading() && !isOnlyRidePlanner()) {
  <button mat-fab extended aria-label="Gebruiker toevoegen" (click)="newUser()">
    <mat-icon>add</mat-icon>
  </button>
}
<input hidden type="file" accept=".xlsx" #uploader (change)="uploadedFile($event)" />
